import React, { Component } from 'react';
import { getGlobalStorage } from '@platform/api';
import classnames from 'classnames';
import './index.less';

let globalTableConfig = JSON.parse(getGlobalStorage('localStorage', 'nccTable')) || {};

export default function useStyle(Table) {
    return class StyleTable extends Component {
        render() {
            let {
                crossCheck = false, // 是否斑马线
                cuttingCheck = true, // 是否分割线
                tableType = 'standard',
            } = globalTableConfig;

            let { flex } = this.props;

            return <div 
                className={classnames("table-style-wrapper", {
                    'crossing-style': crossCheck,
                    'split-style': cuttingCheck,
                    'flex-container': flex,
                    [`table-style-${tableType}`]: true,
                })}
            >
                <Table {...this.props}></Table>
            </div>;
        }
    };
}

useStyle.displayName = 'useStyle';
useStyle.dependence = [];